import dayjs from 'dayjs';
import TestRunnerService from '../services/test-runner';
import { RUN_STATUS, SUCCESS_STATUS } from './test-runner-constants';

const TIME_DELIMITER = ':';
const POLL_DELAY_IN_MILLISECONDS = 10 * 1000;

export function convertDuration(duration) {
	if (duration == null) {
		return '';
	}
	if (duration == 0) {
		return ' < 1 sec';
	}
	const parsedDuration = dayjs.duration(duration * 1000);

	let durationString = '';
	if (parsedDuration.days() > 0) {
		durationString += parsedDuration.days() + (parsedDuration.days() > 1 ? ' days ' : ' day ');
	}
	if (parsedDuration.hours() > 0  || durationString) {
		durationString += zeroPad(parsedDuration.hours()) + TIME_DELIMITER;
	}
	durationString += zeroPad(parsedDuration.minutes()) + TIME_DELIMITER;
	durationString += zeroPad(parsedDuration.seconds());

	return durationString;
}

function zeroPad(num) {
	if (num < 10) return '0' + num;
	return num;
}

export function sortByFullPath(f) {
	return f.sort((a, b) => a.fullPath ? a.fullPath.toLowerCase().localeCompare(b.fullPath && b.fullPath.toLowerCase()) : -1);
}

export function formatDate(date, withTime) {
	if (!date) return;
	let dayjsObj = dayjs(date);
	return dayjsObj.format(withTime ? 'MM/DD/YYYY HH:mm:ss' : 'MM/DD/YYYY');
}

export function startPolling(runId, state) {
	state.pollTimeoutId = setTimeout(() => getTestRunByRunId(runId, state), POLL_DELAY_IN_MILLISECONDS);
}

export function stopPolling(state) {
	if (state.pollTimeoutId) {
		clearTimeout(state.pollTimeoutId);
	}
}

function getTestRunByRunId (runId, state) {
	state.loading = true;
	state.error = null;
	return TestRunnerService.instance()
		.getTestRunByRunId(runId)
		.then((response) => {
			if (response.status == SUCCESS_STATUS && response.data) {
				state.testRun = response.data;
				state.loading = false;
				state.error = null;
				if (response.data.status === RUN_STATUS.RUNNING) {
					startPolling(runId, state);
				}
				return response.data;
			} else {
				state.error = "Could not fetch last test run, response status: " + response.status;
				throw state.error;
			}
		}).catch((err) => {
			state.loading = false;
			state.error = err;
		});
}

export function fetchTestRun(runId, state) {
	return getTestRunByRunId(runId, state);
}

export function cancelTestRun(runId, state) {
	if (runId && confirm("Cancel test run?")) {
		state.loading = true;
		state.error = null;
		return TestRunnerService.instance()
			.cancelTestRun(runId)
			.then((response) => {
				if (response.status == SUCCESS_STATUS && response.data) {
					stopPolling(state);
					return fetchTestRun(runId, state);
				} else {
					state.error = "Could not cancel tests, response status: " + response.status;
				}
				state.loading = false;
			}).catch((err) => {
				state.loading = false;
				state.error = err;
			});
	}
}

export function cancelTest(id, runId, state) {
	if (id && runId && confirm("Cancel test?")) {
		state.loading = true;
		state.error = null;
		return TestRunnerService.instance()
			.cancelTest(id)
			.then((response) => {
				if (response.status == 200) {
					stopPolling(state);
					return fetchTestRun(runId, state);
				} else {
					state.error = "Could not cancel test, response status: " + response.status;
				}
				state.loading = false;
			}).catch((err) => {
				state.loading = false;
				state.error = err;
			});
	}
}
